// navigator.clipboard only exists in secure contexts (HTTPS or localhost); on a
// plain http:// LAN address it is undefined and every copy button threw. The
// fallback is the old hidden-textarea + execCommand("copy"), which still works
// there as long as it runs inside the click that asked for it.
export default function copyToClipboard(text: string): void {
	if (navigator.clipboard?.writeText) {
		navigator.clipboard.writeText(text).catch(() => copyWithTextarea(text));
		return;
	}

	copyWithTextarea(text);
}

function copyWithTextarea(text: string): void {
	const textarea = document.createElement("textarea");
	textarea.value = text;
	textarea.setAttribute("readonly", "");
	textarea.style.position = "fixed";
	textarea.style.opacity = "0";
	document.body.appendChild(textarea);
	textarea.select();
	try {
		document.execCommand("copy");
	} finally {
		document.body.removeChild(textarea);
	}
}
